import { styled } from '@mui/material';

import { TABLET_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '100px',
  width: '100%',
  zIndex: 10,
}));

export const StyledTitleWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 8,
  paddingBottom: '63px',
  paddingTop: '100px',
  alignItems: 'center',
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    flexDirection: 'column',
    paddingTop: '60px',
    paddingBottom: '30px',
  },
}));

export const StyledTable = styled('div')(({ theme }) => ({
  width: '100%',
  backgroundColor: COLORS.white,
  borderRadius: '20px',
  boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.05)',
  overflow: 'hidden',
  padding: '26px 24px',
  position: 'relative',

  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    padding: '26px 0',
  },
}));

export const StyledHeader = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: COLORS.white,
  height: '25px',
  alignItems: 'center',
}));

interface StyledRowProps {
  $colored?: boolean;
}

export const StyledRow = styled('div')<StyledRowProps>((props) => ({
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: props.$colored ? '#FAFAFA' : COLORS.white,
  padding: props.$colored ? '10px 12px 11px' : '21px 12px',
  boxSizing: 'border-box',
}));

interface StyledCellProps {
  $isTextCenter?: boolean;
  $centered?: boolean;
}

export const StyledCell = styled('div')<StyledCellProps>((props) => ({
  flex: 1,
  textAlign: props.$isTextCenter ? 'center' : 'unset',
  ...(props.$centered && {
    display: 'flex',
    justifyContent: 'center',
  }),
}));
